import { render } from "./ObjectivesSection.vue?vue&type=template&id=380f5de0"
const script = {}

import "./ObjectivesSection.vue?vue&type=style&index=0&id=380f5de0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__